import React from "react";
import { Link } from "react-router-dom";

function Slider3({ setTab }) {
  return (
    <div className="image-container" id="slider3">
      <div className="overlay"></div>
      <div className="image-half">
        <img
          src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/bg-image/checkup.jpg"
          alt="checkup"
        />
      </div>
      <div className="content">
        <span className="heading1">More Real</span>
        <br />
        <span className="heading2">
          Vision For a <span style={{ color: "#12b48b" }}>Better</span> Life
        </span>
        <br />
        <p className="para">
          Because the safety of your visual health is our primary concern,
          <br />
          operates under strictest clinical governance
        </p>
        <Link
          to="/appointment"
          className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor margin_top15"
          onClick={() => setTab("appointment")}
        >
          Book Appointment
        </Link>
      </div>
    </div>
  );
}

export default Slider3;
